import { Pipe, PipeTransform } from '@angular/core';
import { MAP_CONFIDENCE_340B } from '@module-claims/enums/confidence-340b.enum';

@Pipe({
  name: 'confidence340b',
  standalone: false
})
export class Confidence340bPipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) {
      return '';
    }

    return MAP_CONFIDENCE_340B[value] ?? value;
  }
}
